export default function encodeBase64(value) {
    return btoa(unescape(encodeURIComponent(value)));
}

export function decodeBase64(value) {
    return atob(unescape(encodeURIComponent(value)));
}
